import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { keyframes, style } from '@vanilla-extract/css';

const shimmerKeyframes = keyframes({
  '0%': {
    backgroundPosition: '200% 0',
  },
  '100%': {
    backgroundPosition: '-200% 0',
  },
});

export const shimmerText = style(
  {
    background: `linear-gradient(90deg,
    ${themeVars.color['text-bold']} 0%,
    ${themeVars.color['text-minimal']} 50%,
    ${themeVars.color['text-bold']} 100%)`,
    backgroundSize: '200% auto',
    color: 'transparent',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    animation: `${shimmerKeyframes} 2s linear infinite`,
    display: 'inline-block',
  },
  'shimmer-text',
);

export const shimmerTextGradient = style(
  {
    background: `linear-gradient(90deg,
    ${themeVars.palette['purple-500']} 0%,
    ${themeVars.palette['orange-400']} 50%,
    ${themeVars.palette['purple-500']} 100%)`,
    backgroundSize: '200% auto',
    color: 'transparent',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    animation: `${shimmerKeyframes} 2s linear infinite`,
    display: 'inline-block',
    opacity: 0.75,
  },
  'shimmer-text-gradient',
);
